import classNames from 'classnames';
import { customAlphabet } from 'nanoid';
import React, { useEffect, useState } from 'react';
import Dropzone, { ErrorCode } from 'react-dropzone';
import IconRemove from '../../images/icon-cross-blue.svg';
import IconUpload from '../../images/icon-upload.svg';
import { isFileUploadError, uploadFiles } from '../upload.service';
const MAX_FILE_SIZE_IN_MB = 20;
const ERROR_CODE = {
    [ErrorCode.FileInvalidType]: 'Ungültiges Dateiformat',
    [ErrorCode.FileTooLarge]: `Datei ist zu groß (max. ${MAX_FILE_SIZE_IN_MB}MB)`,
    [ErrorCode.FileTooSmall]: 'Datei ist zu klein',
    [ErrorCode.TooManyFiles]: 'Zu viele Dateien',
};
const requestId = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 8)();
const UploadArea = ({ pageId, onFileListChange }) => {
    const [rejectedFiles, setRejectedFiles] = useState([]);
    const [uploadErrors, setUploadErrors] = useState({});
    const [acceptedFiles, setAcceptedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const isUploading = acceptedFiles.length > 0;
    useEffect(() => {
        if (acceptedFiles.length === 0) {
            return;
        }
        uploadFiles(acceptedFiles, requestId, pageId)
            .then(res => {
            Object.entries(res).forEach(([fileName, result]) => {
                if (isFileUploadError(result)) {
                    setUploadErrors(cur => ({ ...cur, [fileName]: result.error }));
                }
                else {
                    setUploadedFiles(cur => {
                        const alreadyExists = cur.find(entry => entry.id === result.id);
                        if (alreadyExists) {
                            return cur;
                        }
                        return [...cur, { id: result.id, fileName, size: result.size }];
                    });
                }
            });
        })
            .catch(err => console.error(err))
            .finally(() => setAcceptedFiles([]));
    }, [acceptedFiles]);
    useEffect(() => {
        onFileListChange(uploadedFiles);
    }, [uploadedFiles]);
    return (React.createElement("div", { className: 'upload-area' },
        React.createElement(Dropzone, { onDrop: (accepted, rejected) => {
                setAcceptedFiles(accepted);
                setRejectedFiles(rejected);
            }, accept: { 'image/*': [], 'application/pdf': [] }, maxSize: MAX_FILE_SIZE_IN_MB * 1000 * 1000, disabled: isUploading }, ({ getRootProps, getInputProps, isDragAccept, isDragReject }) => (React.createElement("div", { ...getRootProps({
                className: classNames('dropzone', {
                    'is-drag-accept': isDragAccept,
                    'is-drag-reject': isDragReject,
                    'is-disabled': isUploading,
                }),
            }) },
            React.createElement("input", { ...getInputProps() }),
            isUploading ? (React.createElement("i", null, "Dateien werden hochgeladen...")) : (React.createElement("div", null,
                React.createElement(IconUpload, null),
                React.createElement("p", { className: 'label' }, "Dokument hochladen"),
                React.createElement("p", { className: 'instructions' },
                    React.createElement("span", { className: 'is-desktop-only' }, "per Dateiauswahl oder Drag & Drop"),
                    React.createElement("span", { className: 'is-mobile-only' }, "Dateiauswahl \u00F6ffnen"),
                    React.createElement("br", null),
                    "Bild- oder PDF-Dateien (max. ",
                    MAX_FILE_SIZE_IN_MB,
                    "MB)")))))),
        rejectedFiles.length > 0 && (React.createElement("div", { className: 'error-list' }, rejectedFiles.map(rejection => (React.createElement("div", { key: rejection.file.name, className: 'form-elements-error-message' },
            "\"",
            rejection.file.name,
            "\" nicht akzeptiert:",
            ' ',
            React.createElement("i", null, rejection.errors.map(err => ERROR_CODE[err.code]).join(', '))))))),
        Object.keys(uploadErrors).length > 0 && (React.createElement("div", { className: 'error-list' }, Object.entries(uploadErrors).map(([fileName, error]) => (React.createElement("div", { key: fileName, className: 'form-elements-error-message' },
            "\"",
            fileName,
            "\" konnte nicht hochgeladen werden: ",
            React.createElement("i", null, error)))))),
        uploadedFiles.length > 0 && (React.createElement("div", { className: 'uploaded-list' },
            "Hochgeladene Dateien:",
            React.createElement("br", null),
            uploadedFiles.map(upload => (React.createElement("div", { className: 'uploaded-file', key: upload.id },
                React.createElement("span", null, upload.fileName),
                React.createElement("button", { className: 'btn-remove', title: 'Datei entfernen', onClick: () => setUploadedFiles(uploadedFiles.filter(entry => entry.id !== upload.id)) },
                    React.createElement(IconRemove, null)))))))));
};
export default UploadArea;
